/**
 * @generated SignedSource<<60b320f93fac7329ef5b401e1109f6a8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type appBuildNumber_Query$variables = {};
export type appBuildNumber_Query$data = {
  readonly Admin: {
    readonly App: {
      readonly GetAppBuildNumbers: {
        readonly " $fragmentSpreads": FragmentRefs<"appBuildNumber_AppVersionFragment">;
      };
    };
  };
};
export type appBuildNumber_Query = {
  response: appBuildNumber_Query$data;
  variables: appBuildNumber_Query$variables;
};

const node: ConcreteRequest = {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "appBuildNumber_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminQueryType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AppAdminSchema",
            "kind": "LinkedField",
            "name": "App",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AppVersion",
                "kind": "LinkedField",
                "name": "GetAppBuildNumbers",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "appBuildNumber_AppVersionFragment"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "appBuildNumber_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminQueryType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AppAdminSchema",
            "kind": "LinkedField",
            "name": "App",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AppVersion",
                "kind": "LinkedField",
                "name": "GetAppBuildNumbers",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "iosBuildNumber",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "androidBuildNumber",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6b671a224807566b79ec1e40a25527b1",
    "id": null,
    "metadata": {},
    "name": "appBuildNumber_Query",
    "operationKind": "query",
    "text": "query appBuildNumber_Query {\n  Admin {\n    App {\n      GetAppBuildNumbers {\n        ...appBuildNumber_AppVersionFragment\n        id\n      }\n    }\n  }\n}\n\nfragment appBuildNumber_AppVersionFragment on AppVersion {\n  iosBuildNumber\n  androidBuildNumber\n}\n"
  }
};

(node as any).hash = "b7faded50ae5c027868869af4bba8070";

export default node;
